/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelBrokerageWorkflow.ts             *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const AutogenUserSavedSearchEndpoint = "lme/powerbroker/brokerage-workflow";

export class AutogenModelBrokerageWorkflow<RowType extends ModelRow> extends Endpoint<RowType, RowBrokerageWorkflowFields> {
    constructor(ctor: RowConstructor) {
        super(AutogenUserSavedSearchEndpoint, ctor);
    }
}

export class AutogenRowBrokerageWorkflow extends ModelRow<RowBrokerageWorkflowFields> {
    constructor(values?: Partial<RowBrokerageWorkflowFields>) {
        super(AutogenUserSavedSearchEndpoint, true, values);
    }
}

export interface RowBrokerageWorkflowFields {
    company_id: string;
    descr: string;
    id: string;
    is_active: string;
}

